import React from 'react';
import PieChart from 'components/pie-chart';
import styles from './style.module.scss';

interface Props {
  title: string;
  data: { value: string; percentage: number }[];
}

export default function ChartWithLegend({ title, data }: Props) {
  return (
    <div>
      <div className={styles.title}>{title}</div>
      <div className={styles['chart-with-legend']}>
        <div className={styles['legend-container']}>
          {data.map((dataPoint, index) => {
            return (
              <div className={styles.legend} key={index}>
                <span className={styles['legend-color-value']}>
                  <span className={`${styles['legend-color']} ${styles[`legend-color-${index}`]}`}/>
                  {dataPoint.value}
                </span>
                <span className={styles.value}>
                  {dataPoint.percentage}%
                </span>
              </div>
            );
          })}
        </div>
        <PieChart data={data} />
      </div>
    </div>
  );
}
